import {
  Divider,
  MassiveMusicHorizontal,
  SongtradrHorizontal,
} from "@songtradr/design-language";
import { Container } from "./SongtradrGroupLogos.Parts";

export const SongtradrGroupLogos = () => (
  <Container>
    <SongtradrHorizontal />
    <Divider $direction="vertical" />
    <MassiveMusicHorizontal />
  </Container>
);
